/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";
import { useTranslation } from "react-i18next";
import TkOutSourcingShipDetailCreateButton from "../input/TkOutSourcingShipDetailCreateButton";
import DeleteSingleRecordButton from "../input/DeleteSingleRecordButton";
import SaveToExcelButton from "../input/SaveToExcelButton";
import defineConf from "../../config/defineConf";

function TkOutSourcingShipDetail(props) {
    const table = "TkOutSourcingShipDetail";
    const view = "TkVwOutSourcingShipDetail";

    const { id, onSelectMst, onDetailEmpty } = props;

    const { t } = useTranslation();

    const [tkOutSourcingShipDetailSchema, setTkOutSourcingShipDetailSchema] = useState();
    const [tkOutSourcingShipDetailGrid, setTkOutSourcingShipDetailGrid] = useState();
    const [tkOutSourcingShipDetailApi, setTkOutSourcingShipDetailApi] = useState();
    const [tkOutSourcingShipDetailData, setTkOutSourcingShipDetailData] = useState();
    const [tkOutSourcingShipDetailDataIsEmpty, setTkOutSourcingShipDetailDataIsEmpty] = useState();

    const [, setNotification] = useRecoilState(notificationState);

    useEffect(() => {
        let mounted = true;

        (async () => {
            let schema = await getSchema(table);

            if (mounted) {
                setTkOutSourcingShipDetailSchema(schema);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        if (tkOutSourcingShipDetailApi) {
            tkOutSourcingShipDetailApi.refresh();
        }
    }, [onSelectMst.outSourcingShipId]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const onPartialFailure = (msg) => {
        notifyWarning(msg);
    };

    const onDialogUpdateDetail = () => {
        if (tkOutSourcingShipDetailApi) {
            tkOutSourcingShipDetailApi.refresh();
        }
    };

    const doHandleBackendErrorMsg = (reason) => {
        // reason.response := { data, status, statusText, headers, config, request }
        // data : user error message
        // status : http status code
        // statusText : http status code text
        const response = reason.response;
        return `${response.data} `;
    };

    return (
        <BasicCrudScreenType
            id={id}
            headerTitle={t("term.outSourcingShipDetail")}
            table={table}
            view={view}
            onModifyViewUrl={(url) => `${url}/${onSelectMst.outSourcingShipId}`}
            onInitialized={(grid) => {
                grid.selectionMode = "Row";
                setTkOutSourcingShipDetailGrid(grid);
            }}
            onApiInitialized={(api) => {
                setTkOutSourcingShipDetailApi(api);
            }}
            onLoadData={(data) => {
                setTkOutSourcingShipDetailData(data);

                const isEmpty = data.length < 1 ? true : false;

                setTkOutSourcingShipDetailDataIsEmpty(isEmpty);
                onDetailEmpty(isEmpty);
            }}
            onAppendButtonInFrontOfSearch={() => (
                <BasicCrudScreenActionItemLayout>
                    <AccessControl
                        accessTarget={tkOutSourcingShipDetailSchema && tkOutSourcingShipDetailSchema.name}
                        accessMethod="POST"
                    >
                        <TkOutSourcingShipDetailCreateButton
                            id={id}
                            schema={tkOutSourcingShipDetailSchema}
                            refresh={tkOutSourcingShipDetailApi}
                            disabled={
                                onSelectMst?.outSourcingShipState === defineConf.outSourcingShipState.SHIP_COMPLETE
                            }
                            onSuccess={onSuccess}
                            onSelectMst={onSelectMst}
                            customizeErrorMsgCallback={doHandleBackendErrorMsg}
                            onDialogUpdateDetail={onDialogUpdateDetail}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tkOutSourcingShipDetailSchema && tkOutSourcingShipDetailSchema.name}
                        accessMethod="DELETE"
                    >
                        <DeleteSingleRecordButton
                            id={id}
                            schema={tkOutSourcingShipDetailSchema}
                            grid={tkOutSourcingShipDetailGrid}
                            refresh={tkOutSourcingShipDetailApi}
                            makeItemName={(row) => {
                                return `${t("columnName.outSourcingShipDetailId")}: ${row.outSourcingShipDetailId}`;
                            }}
                            color="secondary"
                            disabled={
                                tkOutSourcingShipDetailDataIsEmpty ||
                                onSelectMst?.outSourcingShipState === defineConf.outSourcingShipState.SHIP_COMPLETE
                            }
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            onPartialFailure={onPartialFailure}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tkOutSourcingShipDetailSchema && tkOutSourcingShipDetailSchema.name}
                        accessMethod="SAVETOEXCEL"
                    >
                        <SaveToExcelButton
                            id={id}
                            grid={tkOutSourcingShipDetailGrid}
                            view={view}
                            color="primary"
                            disabled={tkOutSourcingShipDetailDataIsEmpty}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            )}
            noCreate
            noEdit
            noDelete
            noExcel
        />
    );
}

export default TkOutSourcingShipDetail;
